import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import CommonTab from '../../components/tabComponent/CommonTab';
import DealerManagement from '../dealerManagement/DealerManagement';
import DealerProgramAssocation from '../dealerProgramAssocation/DealerProgramAssocation';
import ProgramManagement from '../ProgramManagement/ProgramManagement';
var isAnyActionEnabled = function (permission) {
    if (!permission)
        return false;
    return (permission.View === 1 ||
        permission.Add === 1 ||
        permission.Update === 1 ||
        permission.Delete === 1);
};
var PortalSetup = function () {
    var _a = useState(0), activeTab = _a[0], setActiveTab = _a[1];
    var rolePermissions = useSelector(function (store) { var _a; return ((_a = store.User.userData) === null || _a === void 0 ? void 0 : _a.RolePermissions) || []; });
    var canView = function (permissionKey) {
        var exact = rolePermissions.find(function (permission) { return permission.PermissionKey === permissionKey; });
        return isAnyActionEnabled(exact);
    };
    var tabs = useMemo(function () { return [
        canView('ADMINISTRATOR:PORTAL_SETUP:PORTAL_MGMT')
            ? {
                label: 'Portal Management',
                content: React.createElement(DealerManagement, null),
            }
            : null,
        canView('ADMINISTRATOR:PORTAL_SETUP:DEALER_PROGRAM_ASSOCIATION')
            ? {
                label: 'Dealer Program Association',
                content: React.createElement(DealerProgramAssocation, null),
            }
            : null,
        canView('ADMINISTRATOR:PORTAL_SETUP:PROGRAM_MGMT')
            ? {
                label: 'Program Management',
                content: React.createElement(ProgramManagement, null),
            }
            : null,
    ].filter(Boolean); }, [rolePermissions]);
    if (!tabs.length) {
        return null;
    }
    return (React.createElement(CommonTab, { tabs: tabs, activeIndex: activeTab, onTabChange: setActiveTab }));
};
export default PortalSetup;
